const MeasureStatusEnum = {
  AGUARDANDO_APROVACAO: '100',
  APROVADO_GESTOR: '150',
  FATURADO: '160',
  REPROVADO: '190',
  CANCELADO: '191',
}
export default MeasureStatusEnum
